import { Grid, Typography, withStyles } from '@material-ui/core';
import { Button, Card, InfoBulle, InputField } from 'bc-front-sagacomponents';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Layout from '../../components/Layout';
import IllustrationCompteSvg from '../../images/illustration-compte';
import { setConfirmationCreationCompte } from '../../redux/CompteRedux';
import history from '../../services/history';
import { useCreationCompte } from './selectors';
import styles from './style';

interface Props {
  classes?: any;
}
const CreationComptePage = (props: Props) => {
  const { classes } = props;

  const {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    response,
    fetching,
    errorApi,
    setParamsCreationCompte,
  } = useCreationCompte();

  const [captchaValue, setCaptchaValue] = useState();
  const [errorCaptcha, setErrorsCaptcha] = useState<string | undefined>();
  const onSubmit = (data) => {
    if (captchaValue) {
      setParamsCreationCompte({ ...data, tokenCaptcha: captchaValue });
    } else {
      setErrorsCaptcha("Veuillez prouver que vous n'êtes pas un robot");
    }
  };

  const dispatch = useDispatch();
  // const stateCallback = useCallback(dispatch, [dispatch]);

  useEffect(() => {
    if (response) {
      dispatch(setConfirmationCreationCompte(true));
      history.push('/');
    }
  }, [response, dispatch]);

  return (
    <Layout>
      <div className={classes.title}>
        <Typography variant="h2">
          Créer<strong> mon compte</strong>
        </Typography>
      </div>

      <div className={classes.container}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Card>
              <InputField
                name="numeroAdhesion"
                label="N° d'adhésion (Uniquement les 7 premiers chiffres)"
                required
                pattern={{
                  value: /^\d+$/,
                  message: "Merci de saisir un numéro d'adhésion valide (seulement des chiffres)",
                }}
                value={watch('numeroAdhesion')}
                errors={errors.numeroAdhesion}
                register={register}
              />
              <InputField
                name="email"
                label="Email"
                value={watch('email')}
                pattern={{
                  value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: 'Merci de saisir une adresse email valide',
                }}
                required
                errors={errors.email}
                register={register}
              />
              <br />
              <ReCAPTCHA
                sitekey="6LfHbzMsAAAAAOxUxWVhQxCC0dN6-hWy67pOddGV"
                onChange={(value) => {
                  setCaptchaValue(value);
                  setErrorsCaptcha(undefined);
                }}
              />
              {errorCaptcha && (
                <Typography variant="body2" color="error">
                  {errorCaptcha}
                </Typography>
              )}
            </Card>
            <div className={classes.btnActions}>
              <Button variant="contained" color="primary" title={'Valider'} type="submit" fetching={fetching}></Button>
            </div>
            {!fetching &&
              errorApi &&
              errorApi.response &&
              errorApi.response.data &&
              errorApi.response.data.code === '409' && (
                <Grid container justify="flex-end" className={classes.infoContainer}>
                  <InfoBulle type="info" />
                  <Typography color="primary">
                    Compte déjà existant, la visualisation de votre contrat est possible en vous connectant à ce compte
                    et en cliquant sur "Ajouter un contrat" dans la page d’accueil
                  </Typography>
                </Grid>
              )}
            {!fetching &&
              errorApi &&
              errorApi.response &&
              errorApi.response.data &&
              errorApi.response.data.code !== '409' &&
              errorApi.response.data.description && (
                <Grid container justify="flex-end" className={classes.errorContainer}>
                  <Typography color="error">{errorApi.response.data.description}</Typography>
                </Grid>
              )}
            {!fetching && errorApi && errorApi.response && errorApi.response && !errorApi.response.data && (
              <Grid container justify="flex-end" className={classes.errorContainer}>
                <Typography color="error">Valeurs incorrectes</Typography>
              </Grid>
            )}
          </form>
        </FormProvider>
        <div className={classes.illu}>
          <IllustrationCompteSvg></IllustrationCompteSvg>
        </div>
      </div>
    </Layout>
  );
};

export default withStyles(styles)(CreationComptePage);
